/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ApproveBigCommerceRequest
 */
export interface ApproveBigCommerceRequest {
  /**
   *
   * @type {string}
   * @memberof ApproveBigCommerceRequest
   */
  companyId: string;
}

/**
 * Check if a given object implements the ApproveBigCommerceRequest interface.
 */
export function instanceOfApproveBigCommerceRequest(
  value: object,
): value is ApproveBigCommerceRequest {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  return true;
}

export function ApproveBigCommerceRequestFromJSON(
  json: any,
): ApproveBigCommerceRequest {
  return ApproveBigCommerceRequestFromJSONTyped(json, false);
}

export function ApproveBigCommerceRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApproveBigCommerceRequest {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"],
  };
}

export function ApproveBigCommerceRequestToJSON(
  json: any,
): ApproveBigCommerceRequest {
  return ApproveBigCommerceRequestToJSONTyped(json, false);
}

export function ApproveBigCommerceRequestToJSONTyped(
  value?: ApproveBigCommerceRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
  };
}
